import './ContentSobreNosotros.css';
import { useNavigate } from 'react-router-dom';
import bannerImg from './img/manos-fondo.jpg';
import angel from './img/cuidatia_angel.png';
import maria from './img/cuidatia_maria.png';
import { useState } from "react";

function CasosUso({nombre, numCasoUso}) {
    switch (numCasoUso) {
        case 0:
            return (
                <div className="container casos">
                        <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className="bloque-abajo" id="busca">
                            <ul>
                                <h3>Usuario</h3>
                                <li>Ayuda a buscar los servicios más cercanos disponibles.</li>
                                <li>Permite encontrar servicios a precios económicos.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Localiza los servicios disponibles que estén próximos a la localización de la empresa.</li>
                                <li>Permite comparar precios de diferentes servicios para ahorrar costes.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        case 1:
            return (
                <div className="container casos">
                        <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className="bloque-abajo" id="servicios">
                            <ul>
                                <h3>Usuario</h3>
                                <li>Proporciona información sobre los servicios que más puntuación tienen.</li>
                                <li>Muestra los servicios más populares y buscados, aquello que todo el mundo utiliza.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Permite a la empresa obtener información acerca de los servicios más utilizados de la plataforma.</li>
                                <li>Gracias a esto, la empresa puede obtener información sobre los mejroes servicios ofrecidos.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        case 2:
            return (
                <div className="container casos">
                        <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className='bloque-abajo' id='ia'>
                            <ul>
                                <h3>Usuario</h3>
                                <li>Busca alternativas a servicios que el usuario solicite.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Proporciona puntos de vista y valoraciones que la empresa puede que no contemplase.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        case 3:
            return (
                <div className="container casos">
                        <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className='bloque-abajo' id='compania'>
                        <ul>
                            <h3>Usuario</h3>
                            <li>Aquellas personas que se sientan solas, les da cierta compañía.</li>
                            <li>Resuelve dudas sencillas y frecuentes que el apartado de ayuda no contemple.</li>
                        </ul>
                        <ul>
                            <h3>Empresa</h3>
                            <li>Se beneficia de la misma manera que un usuario.</li>
                        </ul>
                        </div>
                    </div>
                </div>
            );
        case 4:
            return (
                <div className="container casos">
                        <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className='bloque-abajo' id='posicion'>
                            <ul>
                                <h3>Usuario</h3>
                                <li>El usuario promedio puede conocer cuáles son las empresas que ofrecen los mejores servicios.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Ayuda a las empresas dando visibilidad a los servicios que pueden ofrecer o solicitar.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        case 5:
            return (
                <div className="container casos">
                    <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className='bloque-abajo' id='usuarios'>
                            <ul>
                                <h3>Usuario</h3>
                                <li>Sirve como recordatorio sobre las citas que tiene reservadas.</li>
                                <li>Permite gestionar su calendario según los servicios contratados.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Permite reservar ciertos servicios o citas con la empresa que lo proporciona.</li>
                                <li>Al igual que a los usuarios, les ayuda a optimizar el calendario.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        default:
            return (
                <div className="container casos">
                    <h3>Casos de Uso: {nombre}</h3>
                    <div className='contenido-cuidatia'>
                        <div className="bloque-abajo" id="busca">
                            <ul>
                                <h3>Usuario</h3>
                                <li>Buscar los servicios más cercanos disponibles.</li>
                                <li>Encontrar servicios a precios económicos.</li>
                            </ul>
                            <ul>
                                <h3>Empresa</h3>
                                <li>Localiza los servicios disponibles que estén próximos a la localización de la empresa.</li>
                                <li>Comparar precios de diferentes servicios para ahorrar costes.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
    }
}

export const ContentSobreNosotros = () => {
    const [numCasosUso, setNumCasosUso] = useState(0);
    const [nombre, setNombre] = useState('Búsqueda y Geolocalizador');

    return (
        <>
            <section className='banner-background'>
                <div className='banner-img'>
                    <img className="img-background-banner" src={bannerImg} alt='banner'></img>
                </div> 
                
                <div class="banner-content">
                    <h1 className='h2-about'>Más de 20 años brindando bienestar</h1>
                    <p>En <b>CUIDATIA</b>, llevamos más de dos décadas proporcionando <strong>servicios domiciliarios</strong> de alta calidad en toda España. Nuestra misión es garantizar <strong>accesibilidad, seguridad y confianza</strong> en el cuidado de personas mayores, dependientes y familias que buscan apoyo profesional en el hogar.</p>
                    {/* <button>SOLICITA INFORMACIÓN</button> */}
                </div>
            </section>
    
            {/* <section id="about-us" className="bg-verde py-5">
                <div className="container section-title">
                    <h2 className='fw-bold'>Nuestra Propuesta de Valor</h2>
                    <p>En <b>CUIDATIA</b>, transformamos la asistencia domiciliaria con <strong>servicios sociosanitarios</strong> y <strong>soluciones tecnológicas</strong> de última generación.</p>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <h3>Accesibilidad Total</h3>
                            <p>Llegamos tanto a <strong>zonas urbanas como rurales</strong>, garantizando atención de calidad en cualquier ubicación.</p>
                        </div>
                        <div className="col-md-4">
                            <h3>Profesionales Certificados</h3>
                            <p>Nuestro equipo está compuesto por <strong>especialistas en salud y cuidados</strong>, asegurando confianza y bienestar.</p>
                        </div>
                        <div className="col-md-4">
                            <h3>Innovación en el Cuidado</h3>
                            <p>Integramos <strong>herramientas tecnológicas</strong> para mejorar la experiencia y optimizar la asistencia.</p>
                        </div>
                    </div>
                </div>
            </section> */}
    
            {/* <section id="about-us" className="container my-5">
                <div className="section-title">
                    <h2 className='fw-bold'>La Experiencia de Ser Cuidado</h2>
                    <p>En <b>CUIDATIA</b>, ponemos a las personas en el centro de todo lo que hacemos. <strong>Queremos que cada cliente se sienta acompañado, seguro y atendido</strong> con la máxima profesionalidad y empatía.</p>
                    <button type="button" className="btn btn-primary" onClick={() =>{navigate('/sobre-nosotros')}}>
                        <b>Contactanos</b>
                    </button>
                </div>
            </section> */}

            <div className="container my-5">
                {/* <!-- INTRODUCCIÓN CON MENSAJE SEO --> */}
                <div class="section-title">
                    <h1 className='h2-about'>CUIDATIA es una plataforma innovadora que conecta a personas mayores, familias, profesionales y administraciones con los mejores servicios sanitarios y sociosanitarios online, adaptados a cada necesidad y territorio.</h1>
                </div>

                {/* <!-- CONTENIDO DESCRIPTIVO --> */}
                <div class="content section">
                    <p>Nacimos para resolver una pregunta clave: ¿cómo encontrar cuidadores en zonas rurales o acceder a atención sociosanitaria digital de forma fácil y segura? Nuestra respuesta es un Marketplace de salud y cuidados donde puedes buscar servicios sociosanitarios en tu zona, contratar cuidados a domicilio online o incluso reservar cita con un profesional sanitario rural, todo en un mismo espacio.</p>

                    <p>Creemos en la tecnología al servicio de las personas. Por eso, además de facilitar la contratación de cuidadores, fisioterapeutas a domicilio y otros profesionales, en CUIDATIA trabajamos para construir una verdadera historia de vida digital de las personas mayores, integrando su bienestar, autonomía y trayectorias de cuidado.</p>

                    <p><strong>CUIDATIA es más que una plataforma:</strong> es un puente entre lo local y lo digital, entre el cuidado tradicional y la innovación.</p>

                    <p><em>Descubre cómo podemos ayudarte a encontrar servicios sanitarios en tu pueblo y acompañarte en cada etapa de la vida.</em></p>
                </div>
            </div>

            
            <div className="container mt-5">
                <div className="section-title">
                    <h2>Nuestro equipo</h2>
                </div>
                <div>
                    <p>Todo el equipo que participa en este proyecto cuenta con <b>formación reglada</b> y específica en sus respectivas áreas de intervención, 
                        garantizando así un servicio <b>profesional y de calidad</b>. Además, <b>todas las empresas promocionadas</b> están debidamente <b>inscritas en los 
                        registros oficiales de sanidad o bienestar social</b>, cumpliendo con los <b>requisitos legales y administrativos</b> exigidos. Asimismo, tanto 
                        los profesionales como las entidades colaboradoras se encuentran <b>validados por la Administración Pública correspondiente</b>, lo que refuerza 
                        la <b>confianza y seguridad</b> en los servicios ofrecidos.</p>
                </div>
                {/*<div className='nuestro-equipo'>
                    <div>
                        <img src={angel} alt='CEO Cuidatia'></img>
                        <h3 className='fw-bold mt-4'>ÁNGEL BARRERA NIETO</h3>
                        <li>CEO de Cuidatia: Empresa especializada en la oferta/demanda de servicios sanitarios y sociosanitatios mediante su plataforma web.</li>
                        <li>CEO de SALUUS: Empresa de investigación y desarrollo de soluciones para el envejecimiento activo.</li>
                        <li>Presidente Comité Organizador Congreso de Economía Plateada.</li>
                        <li>Más de 15 años de experiencia en el sector y la satisfacción de nuestros clientes, avalan nuestra profesionalidad y seriedad en el servicio.</li>
                        
                    </div>
                    <div>
                        <img src={maria} alt='Trabajadora socila'></img>
                        <h3 className='fw-bold mt-4'>MÁRIA BARCO ÁLVAREZ</h3>
                        <li>Trabajadora social. Máster en organización y gestión de centros de servicios sociales.</li>
                        <li>COACH certificada por ASESCO</li>
                        <li>Directora técnica de empresa prestadora de Servicios Sociosanitarios.</li>
                        <li>Dirección de centro sociosanitario para personas Alzheimer durante 15 años.</li>
                        <li>Formadora en ámbito sociosanitario desde hace 20 años.</li>
                    </div>
                </div> */}
            </div>

            <section>
                <div className="container">
                    <div className="section-title">
                        <h2>Nuestro método</h2>
                    </div>
                    <div className='main-metodo'>
                            <p>En <b>CUIDATIA</b>, hemos desarrollado un conjunto de tecnologías únicas y avanzadas para transformar y 
                            mejorar la experiencia de cuidado de las personas en todas las fases de la vida.</p>
                        <div style={{width:'100%'}}>
                            <div className='metodo-arriba'>
                                <div className='busca item'>
                                    <svg class="text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z" clip-rule="evenodd"/>
                                    </svg>

                                    <h3>Buscador y Geolocalizador</h3>
                                    <p>Encuentra y compara servicios en tu área según ubicación y precio.</p>
                                    <button href="#casos-uso" onClick={() =>{setNumCasosUso(0); setNombre('Búsqueda y Geolocalizador')}}>
                                        MAS INFORMACION
							        </button>
                                </div>
                                <div className='servicios item'>
                                    <svg class="text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z"/>
                                    </svg>

                                    <h3>Recomendación de Servicios</h3>
                                    <p className='centro'>Sugerencias de los servicios más buscados y mejor valorados.</p>
                                    <button href="#casos-uso" onClick={() =>{setNumCasosUso(1); setNombre('Recomendación de Servicios')}}>
                                        MAS INFORMACION
							        </button>
                                </div>
                                {/* <div className='ia item'>
                                    <h3>🤖 Asesoramiento con IA</h3>
                                    <p className='centro'>Recibe recomendaciones personalizadas basadas en las necesidades de cualquier usuario.</p>
                                    <div className='button' onClick={() =>{navigate('/sobre-nosotros/#casos-uso'); setNumCasosUso(2); setNombre('Asesoramiento con IA')}}>
								        MAS INFORMACION
							        </div>
                                </div> */}
                                {/* <div className='compania item'>
                                    <h3>💬 Compañía Virtual</h3>
                                    <p className='centro'>Conversa con “MARÍA” en cualquier momento del día y siéntete acompañado siempre.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(3); setNombre('Compañía Virtual')}}>
								        MAS INFORMACION
							        </div>
                                </div> */}
                                {/* <div className='posicion item'>
                                    <span>📈</span>
                                    <h3>Mejora del Posicionamiento</h3>
                                    <p className='centro'>Herramientas para aumentar la visibilidad de las empresas de cuidado.</p>
                                    <div className='button' onClick={() =>{navigate('/#casos-uso'); setNumCasosUso(4); setNombre('Mejora del Posicionamiento')}}>
								        MAS INFORMACION
							        </div>
                                </div> */}
                                <div className='usuarios item'>
                                    <svg class="text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v1a1 1 0 0 0 0 2v1a1 1 0 0 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm3 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-1 7a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3 1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
                                    </svg>

                                    <h3>Gestión de Agenda y Citas</h3>
                                    <p className='centro'>Optimiza la organización de servicios y citas para empresas.</p>
                                    <button onClick={() =>{setNumCasosUso(5); setNombre('Gestión de Agenda y Citas')}}>
                                        MAS INFORMACION
							        </button>
                                </div>
                            </div>
                        </div>
                    </div>                     
                </div>
            </section>

            <div id='casos-uso' className='about'>
                        <CasosUso
                        nombre = {nombre}
                            numCasoUso={numCasosUso}
                        />
            </div>

            {/* <section id='por-que-cuidatia' className='about bg-verde'>
                <div className="container">
                    <div className="section-title">
                        <h2>Por qué CUIDATIA</h2>
                    </div>
                    <div className='contenido-cuidatia'>
                            <p>Cuando eliges <b>CUIDATIA</b> tendrás la libertad de elefir tus cuidados. 
                            Con los mejores profesionales, seguridad, recomendaciones y sobre todo, 
                            fácil de hacer.</p>
                        <div className='bloque-abajo'>
                            <ul className='bg-blanco'>
                                <li>Todas las garantias de compra segura.</li>
                                <li>La garantía de elegir profesionales cualificados y certificados.</li>
                                <li>Es muy fácil de contratar los servicios. Solo 3 pasos: <b>BUSCA</b>, <b>ELIGE</b> y <b>RESERVA</b>. </li>
                            </ul>
                            <ul className='bg-blanco'>
                                <li>Garantía de seguridad. Política de Privacidad.</li>
                                <li>Soporte 24 horas en caso de tener dudas.</li>
                                <li>Uso de IA para ofrecer recomendaciones personalizadas y asistencia continua.</li>
                                <li>Valoraciones verificables de otros usuarios.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    );
};